export const rtrim = (str, trimstr) => {
  if (str.slice(-1 * trimstr.length) == trimstr) str = str.substr(0, str.length - trimstr.length)
  return str
}

export const ltrim = (str, trimstr) => {
  if (str.slice(0, trimstr.length) == trimstr) str = str.substr(trimstr.length)
  return str
}